import { render, staticRenderFns } from "./AndiamoAccessiListComponent.vue?vue&type=template&id=83f70e66&scoped=true"
import script from "./AndiamoAccessiListComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoAccessiListComponent.vue?vue&type=script&lang=js"
import style0 from "./AndiamoAccessiListComponent.vue?vue&type=style&index=0&id=83f70e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f70e66",
  null
  
)

export default component.exports